import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'

// Components
import Layout from './src/components/layout'

// Theme
import theme from './src/theme/theme'
import './src/theme/global.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/lazy'
import 'swiper/css/thumbs'

// Context
import { StoreCheckoutContextProvider } from './src/context/StoreCheckoutContext'
import { LoyaltyLionProvider } from './src/context/LoyaltyLionContext'

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider theme={theme}>{element}</ThemeProvider>
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <StoreCheckoutContextProvider>
      <LoyaltyLionProvider {...props}>
        <Layout {...props}>{element}</Layout>
      </LoyaltyLionProvider>
    </StoreCheckoutContextProvider>
  )
}

/**
 * This should remove the ChunkLoadError Sentry error
 **/
let nextRoute = ``

export const onPreRouteUpdate = ({ location }) => {
  nextRoute = location.pathname
}

window.addEventListener('unhandledrejection', (event) => {
  if (/loading chunk \d* failed./i.test(event.reason)) {
    if (nextRoute) {
      window.location.pathname = nextRoute
    }
  }
})
